import { useEffect, useState } from 'react'
import { MatrixEvent } from 'matrix-js-sdk'
import { getMatrixClient } from 'ducks/chat/utils/client'
import useShadowEvent from './useShadowEvent'

export default function useShadowEventFromRoom(matrixRoomId, eventId) {
  const [event, setEvent] = useState(null)
  useShadowEvent(event)
  useEffect(
    () => {
      async function fetchEvent() {
        if (eventId) {
          const client = getMatrixClient()
          let mxEvent
          try {
            mxEvent = await client.fetchRoomEvent(matrixRoomId, eventId)
            mxEvent = new MatrixEvent(mxEvent)
          } catch (e) {
            mxEvent = null
          }

          setEvent(mxEvent)
        }
      }
      fetchEvent()
    },
    [matrixRoomId, eventId, setEvent]
  )

  return event
}
